var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 1599,
    transform: "translate(-1210 -981)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1210,
    y: -727,
    width: 1365,
    height: 1300,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1104,
    y: -21,
    width: 1153,
    height: 70,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13,
    fill: "white",
    stroke: "#EEF0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 10.1135L13.9453 14.0587L10.0001 18.0039",
    stroke: "#3D4554",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 10.0002L17.9453 13.9454L14.0001 17.8906",
    stroke: "#3D4554",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 1599,
    fill: "white",
    transform: "translate(-1210 -981)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon);
export default __webpack_public_path__ + "static/media/RightArrowIcon.a4390957320b5396c391fad685f1ba66.svg";
export { ForwardRef as ReactComponent };